module.exports = __webpack_public_path__ + "static/media/luberly_3.59d3bd03.png";